import { Guid } from '@fitscovery/common/types';

export namespace UsersActions {

  export class GetUsers {
    static readonly type = '[User] GetUsers';
    constructor() { }
  }
  
  export class AddUser {
    static readonly type = '[User] AddUser';
    constructor(public payload: { email: string; firstName?: string; lastName?: string }) {}
  }
  
  export class GetUserByEmail {
    static readonly type = '[User] GetUserByEmail';
    constructor(public email: string) {}
  }
  
  export class DeleteUserRole {
    static readonly type = '[User] DeleteUserRole';
    constructor(public id: Guid) {}
  }

}
